import React, { useRef } from "react";

function CategoriesSlider({ 
  items, 
  selectedId, 
  onItemSelect, 
  isLoading = false,
  sectionClass = "shop-collection-section-1",
  sliderClass = "shop-collection-slider-3",
  wrapperClass = "shop-collection-wrapper-3",
  slideClass = "shop-collection-slide-3",
  navLeftClass = "shop-collection-nav-3-left",
  navRightClass = "shop-collection-nav-3-right"
}) {
  const scrollRef = useRef(null);

  const scrollByRef = (ref, delta) => {
    if (ref.current) ref.current.scrollBy({ left: delta, behavior: "smooth" });
  };

  return (
    <section className={`flat-spacing-25 ${sectionClass}`}>
      <div className="container shop-collection-section-container">
        <div className="wrap-carousel">
          <div className={`swiper tf-sw-product-sell-1 ${sliderClass}`} style={{ position: "relative" }}>
            <div
              className={`swiper-wrapper no-scrollbar ${wrapperClass}`}
              ref={scrollRef}
              data-few-items={items.length <= 5 ? "true" : "false"}
              style={{
                display: "flex",
                overflowX: "auto",
                scrollSnapType: "x mandatory",
                gap: "12px",
                cursor: "grab",
                padding: "0 16px",
                WebkitOverflowScrolling: "touch",
                justifyContent: items.length <= 5 ? "center" : "flex-start",
              }}
            >
              {items.map((item, i) => (
                <div
                  key={`item-${item.id || item.name}-${i}`}
                  className={`swiper-slide ${slideClass}`}
                  data-item-id={item.id}
                  lazy="true"
                  style={{
                    flex: "0 0 auto",
                    width: "calc((100% - 72px) / 7)",
                    minWidth: "100px",
                    maxWidth: "140px",
                    scrollSnapAlign: "start",
                  }}
                >
                  <div
                    className={`card-product style-8${
                      selectedId === item.id ? " active" : ""
                    }`}
                  >
                    <div className="card-product-wrapper">
                      <div
                        className="product-img"
                        onClick={() => {
                          if (!isLoading) {
                            onItemSelect(item.id);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          className="lazyload img-product"
                          data-src={item.image || item.imgSrc}
                          src={item.image || item.imgSrc}
                          alt={item.name || item.title}
                        />
                        <img
                          className="lazyload img-hover"
                          data-src={item.image || item.imgSrc}
                          src={item.image || item.imgSrc}
                          alt={item.name || item.title}
                        />
                      </div>
                    </div>
                    <div className="card-product-info text-center">
                      <div
                        className="title link"
                        onClick={() => {
                          if (!isLoading) {
                            onItemSelect(item.id);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {item.name || item.title}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div
            className={`nav-sw disable-line nav-next-slider ${navLeftClass}`}
            onClick={() => scrollByRef(scrollRef, -360)}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              cursor: "pointer",
              backgroundColor: "#ffffff",
              border: "none",
              outline: "none",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              borderRadius: "50%",
              width: "44px",
              height: "44px",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#0e5aa7";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(14, 90, 167, 0.3)";
              const icon = e.currentTarget.querySelector(".icon");
              if (icon) icon.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
              const icon = e.currentTarget.querySelector(".icon");
              if (icon) icon.style.color = "#0e5aa7";
            }}
          >
            <span
              className="icon icon-arrow-left"
              style={{
                fontSize: "20px",
                color: "#0e5aa7",
                fontWeight: "bold",
              }}
            ></span>
          </div>
          <div
            className={`nav-sw disable-line nav-prev-slider ${navRightClass}`}
            onClick={() => scrollByRef(scrollRef, 360)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              cursor: "pointer",
              backgroundColor: "#ffffff",
              border: "none",
              outline: "none",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              borderRadius: "50%",
              width: "44px",
              height: "44px",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#0e5aa7";
              e.currentTarget.style.boxShadow =
                "0 6px 16px rgba(14, 90, 167, 0.3)";
              const icon = e.currentTarget.querySelector(".icon");
              if (icon) icon.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
              const icon = e.currentTarget.querySelector(".icon");
              if (icon) icon.style.color = "#0e5aa7";
            }}
          >
            <span
              className="icon icon-arrow-right"
              style={{
                fontSize: "20px",
                color: "#0e5aa7",
                fontWeight: "bold",
              }}
            ></span>
          </div>
          <div className="sw-dots style-2 sw-pagination-sell-1 justify-content-center"></div>
        </div>
      </div>
    </section>
  );
}

export default CategoriesSlider;

